import http from "../../http";

const profitChannel = {
    getProfitChannelList(r) {
        return http.get("/gateway/api/sycompany/pc/profitChannel/getProfitChannelList", r)
    },
    saveChannelObjets(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/profitChannel/saveChannelObjets", r)
    },
    deleteChannel(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/profitChannel/deleteChannel", r)
    },
}
export default profitChannel
